

















import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import SlideContent from './slidersection/SlideContent.vue';
import { ISlide, ISlideSection } from '../../../common/interfaces/frontpage.interface';
import config from '../../../../config';

export default Vue.extend({
  name: `SliderSection`,
  components: { SlideContent, Splide, SplideSlide },
  data(): ISlideSection {
    return {
      splideOptions: {
        arrows: false,
        autoplay: true,
        breakpoints: {
          [config.breakpoints.maxMobile]: {
            height: 500,
          },
        },
        classes: {
          page: `splide__pagination__page my-splide-pagination-page`,
          pagination: `splide__pagination my-splide-pagination`,
        },
        direction: `ttb`,
        height: 400,
        padding: 0,
        pagination: true,
        pauseOnHover: false,
        perPage: 1,
        type: `loop`,
      },
    };
  },
  props: {
    slides: {
      required: true,
      type: Array as () => ISlide[],
    },
  },
});
